import React from "react";
import Comingsoonpage from "../../../common/Comingsoon";

const LeaveApplications = () => {
  return (
    <div>
      <Comingsoonpage />
    </div>
  );
};

export default LeaveApplications;
